import { render, staticRenderFns } from "./WayBillManage.vue?vue&type=template&id=5a3884ee&scoped=true"
import script from "./WayBillManage.vue?vue&type=script&lang=ts"
export * from "./WayBillManage.vue?vue&type=script&lang=ts"
import style0 from "./WayBillManage.vue?vue&type=style&index=0&id=5a3884ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3884ee",
  null
  
)

export default component.exports